import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as EmergencyFundIcon } from "uikit/Icons/emergencyfund-goal.svg"

const EmergencyFund = ({ id, amount, baseUrl, type }) => (
  <Card>
    <Card.Content>
      <Link
        to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
        className="navlink"
      >
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column verticalAlign="middle" width={4}>
              <EmergencyFundIcon />
            </Grid.Column>
            <Grid.Column>
              <span className="GenericCard__LinkTitle">Emergency Fund</span>
              <p
                className="GoalCard_Price"
                style={{
                  fontSize: "2.4em",
                  marginBottom: "0",
                  color: "#8ed72a",
                  paddingTop: "16px"
                }}
              >
                ${amount.toLocaleString()}
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Link>
    </Card.Content>
  </Card>
)

export default EmergencyFund
